export default __webpack_public_path__ + "static/media/Custom-HUD-Altimeter (1 Layer).c91d8fff.jpg";